import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { BaseToolRenderer, EventBus } from "@rdkmaster/lui-sdk";
import { StepFile } from "../../messages/manus-step/message-type";
/**
 * 自定义任务中心界面组件
 */
@Component({
    selector: "lui-manus-show",
    templateUrl: "./manus-show.html",
    styleUrls: ["./manus-show.scss"]
})
export class ManusShow extends BaseToolRenderer implements OnInit {
    // 避免覆盖基类的getter/setter
    @Input()
    set initData(value: any) {
        this._initData = value;
    }
    get initData(): any {
        return this._initData;
    }
    private _initData: any;
    private _autoGetterSetter_ManusShow_files?: StepFile[] = [];
    // 存储文件列表
    public get files(): StepFile[] {
        return this._autoGetterSetter_ManusShow_files;
    }
    // 存储文件列表
    public set files(value: StepFile[]) {
        this._autoGetterSetter_ManusShow_files = value;
    }
    private _autoGetterSetter_ManusShow_selectedFile?: StepFile;
    // 当前选中的文件
    public get selectedFile(): StepFile {
        return this._autoGetterSetter_ManusShow_selectedFile;
    }
    // 当前选中的文件
    public set selectedFile(value: StepFile) {
        this._autoGetterSetter_ManusShow_selectedFile = value;
    }
    private _autoGetterSetter_ManusShow_fileContent?: string = "";
    // 文件内容
    public get fileContent(): string {
        return this._autoGetterSetter_ManusShow_fileContent;
    }
    // 文件内容
    public set fileContent(value: string) {
        this._autoGetterSetter_ManusShow_fileContent = value;
    }
    private _autoGetterSetter_ManusShow_filePath?: string = "";
    public get filePath(): string {
        return this._autoGetterSetter_ManusShow_filePath;
    }
    public set filePath(value: string) {
        this._autoGetterSetter_ManusShow_filePath = value;
    }
    private _autoGetterSetter_ManusShow_loading?: boolean = false;
    // 加载状态
    public get loading(): boolean {
        return this._autoGetterSetter_ManusShow_loading;
    }
    // 加载状态
    public set loading(value: boolean) {
        this._autoGetterSetter_ManusShow_loading = value;
    }
    private _autoGetterSetter_ManusShow_errorMessage?: string = "";
    // 错误信息
    public get errorMessage(): string {
        return this._autoGetterSetter_ManusShow_errorMessage;
    }
    // 错误信息
    public set errorMessage(value: string) {
        this._autoGetterSetter_ManusShow_errorMessage = value;
    }
    constructor(private _eventBus: EventBus, private http: HttpClient, private _cdr: ChangeDetectorRef) {
        super();
    }
    ngOnInit(): void {
        this._eventBus.subscribe(["plan-updated"], (event: Record<string, StepFile[]>) => {
            console.log("plan-updated event >>>>>>>>>>>>>> ", event);
            // 将 event 对象的所有值数组合并成一个扁平的数组
            this.files = Object.values(event).flat() || [];
            this._cdr.detectChanges();
        });
    }
    public isHtmlFile(file: any): boolean {
        return file.name.toLowerCase().match(/\.(html|htm)$/i) !== null;
    }
    public isImageFile(file: any): boolean {
        return file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/i) !== null;
    }
    /**
     * 读取并显示文件内容
     * @param fileName 文件名
     */
    public loadFile(file: StepFile): void {
        this.selectedFile = file;
        this.errorMessage = "";
        this.fileContent = "";
        this.filePath = "";
        const baseUrl = "/api/nae-deep-research/v1"; // 根据实际情况修改
        const fileUrl = `${baseUrl}/work_space/${file.path}`;
        if (this.isHtmlFile(file) || this.isImageFile(file)) {
            this.filePath = fileUrl;
            return;
        }
        this.loading = true;
        this.http.get(fileUrl, { responseType: "text" })
            .subscribe({
            next: (content) => {
                this.fileContent = content;
                this.loading = false;
            },
            error: (error) => {
                console.error("\u8BFB\u53D6\u6587\u4EF6\u5931\u8D25:", error);
                this.errorMessage = `读取文件失败: ${error.message || "\u672A\u77E5\u9519\u8BEF"}`;
                this.loading = false;
            }
        });
    }
}
